import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import Layout from 'components/Layout'
import PosAccounts from 'components/PosAccounts'
import ListFilters from 'components/PosAccounts/ListFilters'

import {
  getOrgName,
  getQueryStringParameters,
} from 'store/AppState/selector'
import { loadFilteredAndPaginatedAttendants } from 'store/Attendants/actions'

const PosAccountsPage = () => {
  const dispatch = useDispatch()
  const { pathname } = useLocation()

  const queryStringParameters = useSelector((state) =>
    getQueryStringParameters(state, pathname)
  )
  const orgName = useSelector(getOrgName)

  const params = {
    ...queryStringParameters,
    orgName,
  }

  useEffect(() => {
    dispatch(loadFilteredAndPaginatedAttendants(params))
  }, [dispatch])

  return (
    <Layout
      navbarContent={
        <ListFilters queryStringParameters={queryStringParameters} />
      }
      mainContent={
        <PosAccounts queryStringParameters={queryStringParameters} />
      }
      isSidebar
      title="POS Accounts"
    />
  )
}

export default PosAccountsPage
